import type { MissionTranslations, WebappMission } from '@/types/types'

const MISSION_TEXT_FIELDS = ['title', 'subtitle', 'ctaLabel'] as const

const mirrorFormalFrenchTranslations = (
  translations: MissionTranslations,
  previous: MissionTranslations | null | undefined
): MissionTranslations => {
  const current = translations.fr
  if (current === undefined || current === previous?.fr) return translations

  return { ...translations, frFormal: current }
}

export const mirrorMissionFormalFrench = (mission: WebappMission, baseline: WebappMission): WebappMission =>
  MISSION_TEXT_FIELDS.reduce((next, field) => {
    const current = next[field]
    if (!current) return next

    const translations = mirrorFormalFrenchTranslations(current, baseline[field])
    if (translations === current) return next

    return { ...next, [field]: translations }
  }, mission)

export const renderMissionText = (
  translations: MissionTranslations | null,
  locale: string,
  values: { points: number; label: string; merchantName: string }
): string => {
  const text = translations?.[locale] || Object.values(translations ?? {})[0] || ''

  return text
    .replace(/\{points\}/g, String(values.points))
    .replace(/\{label\}/g, values.label)
    .replace(/\{merchantName\}/g, values.merchantName)
}
